import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
export function SocialProofStrip() {
  return <div className="w-full bg-[#2c4a2c] text-white py-8 border-y border-[#3d663d]" data-id="element-316">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-317">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left" data-id="element-318">
          <div data-id="element-319">
            <h2 className="text-xl md:text-2xl font-serif italic text-[#faf8f5]" data-id="element-320">
              Lo que más se repite: "quiero energía, no otra dieta"
            </h2>
            <p className="text-[#faf8f5]/70 text-sm mt-1" data-id="element-321">
              Este sistema está construido alrededor de lo que más bloquea la
              energía por la tarde.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-322">
            {['Sistema', 'Plantillas', '14 días'].map(badge => <span key={badge} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#faf8f5]/10 border border-[#faf8f5]/20 text-[#faf8f5] text-sm font-medium backdrop-blur-sm" data-id="element-323">
                <Star className="w-3.5 h-3.5 text-[#d4a853] fill-[#d4a853]" data-id="element-324" />
                {badge}
              </span>)}
          </div>
        </div>
      </div>
    </div>;
}